<div class="platform-container">
  <ng-container *ngFor="let item of visibleItems">
    <!-- Si tiene enlace -->
    <button
      *ngIf="item.medio_plat_class_link_type === 'link' && item.medio_plat_valor; else noMenu"
      mat-icon-button
      [matMenuTriggerFor]="menu"
      [matMenuTriggerData]="{ data: item }"
      matTooltip="{{ item.medio_plat }} > {{ item.medio_plat_clas }}: {{ item.medio_plat_valor }}"
      matTooltipClass="multi-line-tooltip"
    >
      <ng-container *ngIf="item.medio_plat_class_icon_use_material === 1; else faIcon">
        <mat-icon class="platform-icon">{{ item.medio_plat_clas_icon_type }}</mat-icon>
      </ng-container>
      <ng-template #faIcon>
        <i [class]="item.medio_plat_clas_icon_type" class="platform-icon"></i>
      </ng-template>
    </button>

    <!-- Si no tiene enlace -->
    <ng-template #noMenu>
      <button
        mat-icon-button
        matTooltip="{{ item.medio_plat }} > {{ item.medio_plat_clas }}: {{ item.medio_plat_valor }}"
        matTooltipClass="multi-line-tooltip"
      >
        <ng-container *ngIf="item.medio_plat_class_icon_use_material === 1; else faIconNoMenu">
          <mat-icon class="platform-icon">{{ item.medio_plat_clas_icon_type }}</mat-icon>
        </ng-container>
        <ng-template #faIconNoMenu>
          <i [class]="item.medio_plat_clas_icon_type" class="platform-icon"></i>
        </ng-template>
      </button>
    </ng-template>
  </ng-container>
</div>

<!-- Menu de opciones-->
<mat-menu #menu="matMenu">
  <ng-template matMenuContent let-data="data">
    <button mat-menu-item (click)="openLink(data)">
      <mat-icon>open_in_new</mat-icon>
      <span>Abrir enlace</span>
    </button>
    <button mat-menu-item (click)="copyLink(data)">
      <mat-icon>content_copy</mat-icon>
      <span>Copiar texto</span>
    </button>
  </ng-template>
</mat-menu>

